import type { ZuubPayer } from '@/@types/zuub/contracts';
import { StatusChip } from '@/common-components/elements/StatusChip';

interface PayerHeaderProps {
  payer: ZuubPayer | undefined;
  colorCombo: {
    backgroundColor: string;
    color: string;
  };
  firstTwoLetters: string;
  statusChipProps: {
    text: string;
    variant: 'default' | 'success' | 'warning' | 'progress' | 'error';
  };
}

export const PayerHeader = ({
  payer,
  colorCombo,
  firstTwoLetters,
  statusChipProps,
}: PayerHeaderProps) => {
  const payerName = payer?.name || 'Unknown Payer';

  return (
    <div className="vai-flex vai-justify-between vai-items-center vai-mb-6">
      <div className="vai-flex vai-items-center vai-gap-4">
        {/* Payer logo/avatar */}
        <div
          className="vai-w-[50px] vai-h-[50px] vai-rounded-lg vai-flex vai-items-center vai-justify-center vai-font-bold vai-text-2xl"
          style={{
            backgroundColor: colorCombo.backgroundColor,
            color: colorCombo.color,
          }}
        >
          {firstTwoLetters}
        </div>
        <div>
          <h2 className="vai-text-2xl vai-font-semibold vai-text-gray-900">
            {payerName}
          </h2>
        </div>
      </div>
      <div className="vai-flex vai-items-center vai-gap-3">
        <StatusChip
          text={statusChipProps.text}
          variant={statusChipProps.variant}
        />
      </div>
    </div>
  );
};
